import { useEffect, useRef } from 'react'

const SCRIPT_ID = 'google-identity-service'

function loadGoogleScript() {
  if (window.google?.accounts?.id) return Promise.resolve()
  const existing = document.getElementById(SCRIPT_ID)
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener('error', () => reject(new Error('google-script')), { once: true })
    })
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = 'https://accounts.google.com/gsi/client?hl=pt-BR'
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('google-script'))
    document.head.appendChild(script)
  })
}

function buttonWidth(host) {
  const card = host.closest('.login-container') || host
  const style = window.getComputedStyle(card)
  const padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0)
  const inner = card === host ? card.clientWidth : card.clientWidth - padding
  const available = Math.floor(inner || host.clientWidth || 0)
  if (!available) return 280
  return Math.max(200, Math.min(360, available))
}

function GoogleLoginButton({ clientId, disabled, onCredential }) {
  const hostRef = useRef(null)
  const onCredentialRef = useRef(onCredential)
  onCredentialRef.current = onCredential

  useEffect(() => {
    if (!clientId || !hostRef.current) return undefined
    const host = hostRef.current
    let cancelled = false
    let lastWidth = 0

    const paint = () => {
      if (cancelled || !host.isConnected || !window.google?.accounts?.id) return
      const width = buttonWidth(host)
      if (host.childElementCount && Math.abs(width - lastWidth) < 8) return
      lastWidth = width
      host.innerHTML = ''
      window.google.accounts.id.renderButton(host, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        text: 'continue_with',
        shape: 'rectangular',
        logo_alignment: 'left',
        width,
      })
    }

    loadGoogleScript()
      .then(() => {
        if (cancelled || !host.isConnected || !window.google?.accounts?.id) return
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: (response) => {
            if (response?.credential) onCredentialRef.current(response.credential)
          },
          auto_select: false,
        })
        paint()
      })
      .catch((error) => {
        console.warn('Botão do Google não carregou', error?.message || error)
      })

    const observer = new ResizeObserver(() => paint())
    observer.observe(host)

    return () => {
      cancelled = true
      observer.disconnect()
    }
  }, [clientId])

  if (!clientId) return null

  return (
    <div className={`login-google${disabled ? ' is-disabled' : ''}`}>
      <div className="login-divider"><span>ou</span></div>
      <div ref={hostRef} className="login-google-button" />
    </div>
  )
}

export default GoogleLoginButton
